<template>
  <div class="content-box">
    <Title />

    <el-menu
      :default-active="activeIndex"
      class="el-menu-demo"
      mode="horizontal"
    >
      <el-menu-item
        :index="String(index + 1)"
        v-for="(i, index) of dataNav"
        :key="index"
        @click="handleSelect(index)"
      >
        {{ i.label }}</el-menu-item
      >
    </el-menu>

    <div class="mobile-select">
      <el-select v-model="name" @change="handleSelect2">
        <el-option
          v-for="item in dataNav"
          :key="item.value"
          :label="item.label"
          :value="item.value"
        >
        </el-option>
      </el-select>
    </div>

    <Project />
  </div>
</template>

<script>
import { Project } from "shared";

export default {
  name: "project",
  components: {
    Project,
  },
  data() {
    return {
      activeIndex: "1",
      name: "数字生活",
      dataNav: [
        {
          value: "外卖",
          label: "餐饮外卖",
        },
        {
          value: "家政",
          label: "家政服务",
        },
        {
          value: "婚恋",
          label: "婚恋交友",
        },
        {
          value: "票务",
          label: "在线票务",
        },
        {
          value: "服务",
          label: "社区服务",
        },
        {
          value: "家装",
          label: "互联网家装",
        },
        {
          value: "房产",
          label: "互联网房产",
        },
      ],
    };
  },
  created() {
    this.$store.dispatch("getProject", this.dataNav[0].value);
  },
  methods: {
    handleSelect(index) {
      this.$store.dispatch("getProject", this.dataNav[index].value);
    },
    handleSelect2(value) {
      this.$store.dispatch("getProject", value);
    },
  },
};
</script>